import { Autocomplete, TextField } from "@mui/material";
import { PackageFilterDto } from "../../../models/advancedFilters";

interface PackagesFilterOptionProps {
  options: PackageFilterDto[];
  value: PackageFilterDto[];
  onChange: (value: PackageFilterDto[]) => void;
}

const PackagesFilterOption = ({
  options,
  value,
  onChange,
}: PackagesFilterOptionProps): JSX.Element => (
  <Autocomplete
    multiple
    options={options}
    getOptionLabel={(option) => option.name}
    value={value}
    onChange={(_event, newValue) => onChange(newValue)}
    isOptionEqualToValue={(option, val) => option.id === val.id}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Packages"
        placeholder="Select packages"
        size="small"
      />
    )}
  />
);

export default PackagesFilterOption;
